import { z } from 'zod';
export const nomncValidationSchema = z.object({
    id: z.string(),
    data: z
        .object({
        language: z.enum(['en', 'es']).default('en'),
        serviceTypes: z.enum(['SN', 'PT', 'OT', 'ST', 'HHA', 'MSW', 'Others']).array().min(1, 'At least one service type is required'),
        serviceTypeOther: z.string().optional(),
        effectiveDate: z.string().min(10, 'Effective date is required'),
        qioName: z.string().min(1, 'QIO name is required'),
        qioPhone: z.string().min(1, 'QIO toll-free number is required'),
        additionalInformation: z.string().optional(),
        patientSigned: z.literal(true, {
            errorMap: () => ({ message: 'Patient signature is required' }),
        }),
        signedDate: z.string().min(10, 'Signed date is required'),
    })
        .superRefine((data, ctx) => {
        if (data.serviceTypes.includes('Others') && !data.serviceTypeOther?.trim()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['serviceTypeOther'],
                message: 'Other service type is required',
            });
        }
    }),
});
